import React from 'react';

const Footer = () => (
  <footer className="bg-gray-800 text-white p-2 sm:p-4 text-center text-xs sm:text-sm">
    <p>&copy; 2025 IBE. Todos os direitos reservados.</p>
  </footer>
);

export default Footer;
